<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div>
    <PrimeIconField iconPosition="left">
      <PrimeInputIcon class="ri-search-line" />
      <PrimeInputText
        v-model="searchInput"
        class="search-input"
        ref="search"
        type="text"
        :placeholder="$t('search')"
        @keyup.enter="search"
      />
    </PrimeIconField>
  </div>
</template>
<script>
import { mapState } from "pinia";
import { useConfigStore } from "@/stores/config";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";

export default {
  name: "SearchInput",
  components: {
    PrimeIconField: IconField,
    PrimeInputIcon: InputIcon,
    PrimeInputText: InputText,
  },
  props: {
    searchResolver: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  methods: {
    search() {
      if (this.searchResolver) {
        this.searchResolver(this.searchInput);
      } else {
        window.location = `${this.ESPACES_HOST}/espaces/recherche?search=${this.searchInput}`;
      }
    },
  },
  computed: {
    ...mapState(useConfigStore, ["ESPACES_HOST"]),
  },
};
</script>
<style scoped>
.search-input {
  width: 100%;
  height: 100%;
}
</style>
